// טקסטים הקשורים לאישור התאמת הכתובת לכתובת המעודכנת במשרד הפנים.
// ריכוז כל הניסוחים במקום אחד מונע סטיות נוסח בין המסכים השונים.

export const ADDRESS_CONFIRMATION_CHECKBOX_LABEL =
  'אני מאשר/ת כי הכתובת תואמת לכתובת המעודכנת במשרד הפנים';

export const ADDRESS_CONFIRMATION_REQUIRED_ERROR =
  'יש לאשר כי הכתובת תואמת לכתובת המעודכנת במשרד הפנים';

// נוסח ה-banner לתצוגה בדף פרטי הלקוח (יושק כאשר תתווסף סקציית הכתובת לתיק הלקוח)
export const ADDRESS_CONFIRMATION_BANNER_TEXT =
  '⚠️ זוהי הכתובת המעודכנת במשרד הפנים. יש לוודא עדכניות הנתון בכל שינוי.';
